import { COMPONENTS } from '../../components/components.registry';
import { CoreConfig, RecommendationsParentModuleKey, SLOTS } from '../../models';

export const DEFAULT_CORE_CONFIG: CoreConfig = {
  template: COMPONENTS.TEMPLATES.ColumnTemplate,
  enableCache: true,
  position: {
    clientHeaderSelector: null
  },
  components: {
    SearchBox: {
      component: COMPONENTS.SMART.SearchBox,
      order: 1,
      data: {
        slot: SLOTS.template.header
      }
    },
    Empathize: {
      component: COMPONENTS.SMART.Empathize,
      order: 2,
      data: {
        slot: SLOTS.template.header
      }
    },
    RelatedTags: {
      component: COMPONENTS.SMART.RelatedTags,
      order: 3,
      data: {
        slot: SLOTS.template.header
      }
    },
    ToggleFacetsGroups: {
      component: COMPONENTS.SMART.ToggleFacetsGroups,
      order: 4
    },
    Sort: {
      component: COMPONENTS.SMART.Sort,
      order: 5,
      data: {
        slot: SLOTS.template.header
      }
    },
    SortList: {
      component: COMPONENTS.SMART.SortList,
      order: 6,
      data: {
        slot: SLOTS.template.header
      }
    },
    ColumnsPicker: {
      component: COMPONENTS.SMART.ColumnsPicker,
      order: 7,
      data: {
        slot: SLOTS.template.header
      }
    },
    Close: {
      component: COMPONENTS.SMART.Close,
      order: 8,
      data: {
        slot: SLOTS.template.header
      }
    },
    ResultsNumber: {
      component: COMPONENTS.SMART.ResultsNumber,
      order: 9,
      data: {
        slot: SLOTS.template.header
      }
    },
    FacetsGroups: {
      component: COMPONENTS.SMART.FacetsGroups,
      order: 10
    },
    Spellcheck: {
      component: COMPONENTS.SMART.Spellcheck,
      order: 11,
      data: {
        slot: SLOTS.template.body
      }
    },
    ResultsGrid: {
      component: COMPONENTS.SMART.ResultsGrid,
      order: 12,
      data: {
        slot: SLOTS.template.body
      }
    },
    Partials: {
      component: COMPONENTS.SMART.Partials,
      order: 13,
      data: {
        slot: SLOTS.template.body
      }
    },
    FallbackFilters: {
      component: COMPONENTS.SMART.FallbackFilters,
      order: 14,
      data: {
        slot: SLOTS.template.body
      }
    },
    NoResults: {
      component: COMPONENTS.SMART.NoResults,
      order: 15,
      data: {
        slot: SLOTS.template.body
      },
      children: {
        Recommendations: {
          component: COMPONENTS.SMART.Recommendations,
          data: {
            props: {
              type: RecommendationsParentModuleKey.noResults
            }
          }
        }
      }
    },
    EmptySearch: {
      component: COMPONENTS.SMART.EmptySearch,
      order: 16,
      data: {
        slot: SLOTS.template.body
      },
      children: {
        Recommendations: {
          component: COMPONENTS.SMART.Recommendations,
          data: {
            props: {
              type: RecommendationsParentModuleKey.emptySearch
            }
          }
        }
      }
    },
    ScrollToTop: {
      component: COMPONENTS.SMART.ScrollToTop,
      order: 17,
      data: {
        slot: SLOTS.template.overlay
      }
    }
  }
};
